import type { TableQuery } from 'ab-common/dataStructures/tableQuery';

import baseRoute from '../baseRoute';

export type * from './viewModel';
export type * from './queryParams';

type RouteDefinition = `${typeof baseRoute}/${number | ':jobId'}/invoices/table${`?startDate=${string}&endDate=${string}` | ''}${`&query=${string}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/:jobId/invoices/table`;

/**
 * @param startDate YYYY-MM-DD
 * @param endDate YYYY-MM-DD
 */
export const URL = (jobId: number, startDate: string, endDate: string, tableQuery: TableQuery): RouteDefinition =>
	`${baseRoute}/${jobId}/invoices/table?startDate=${startDate}&endDate=${endDate}&query=${encodeURIComponent((JSON.stringify(tableQuery)))}`;
